<template>
  <div class="container admin">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>学长</el-breadcrumb-item>
        <el-breadcrumb-item>分享统计</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">分享统计</h2>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div class="filters card">

      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="分享人"
                      prop="share_user_keyword">
          <el-input v-model="query.share_user_keyword"
                    placeholder="请输入"
                    @input="fetchSeniorApplyList(true)"></el-input>
        </el-form-item>
        <el-form-item label="分享码关键字"
                      prop="extend_note_keyword">
          <el-input v-model="query.share_code_keyword"
                    placeholder="请输入分享码"
                    @input="fetchSeniorApplyList(true)"></el-input>
        </el-form-item>
        <el-form-item label="昵称关键字"
                      prop="nickname_keyword">
          <el-input v-model="query.nickname_keyword"
                    placeholder="请输入昵称关键词"
                    @input="fetchSeniorApplyList(true)"></el-input>
        </el-form-item>
        <el-form-item label="统计数据排序规则"
                      prop="statistic_count_order_type">
          <el-select v-model="query.statistic_count_order_type"
                     clearable
                     placeholder="请选择"
                     style="width: 300px"
                     @change="fetchSeniorApplyList(true)">
            <el-option v-for="item in filter.statistic_types"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统计时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          clearable
                          @change="timechange"
                          style="width:400px;"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>

      </el-form>
      <div class="divider"></div>
      <div class="action-wrap">
        <el-button type="primary"
                   @click="handleSearch">搜索</el-button>
        <el-button @click="handleFormReset('searchForm')">重置</el-button>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="序号"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="realname"
                           label="分享人"
                           width="200"
                           align="center">
            <template slot-scope="scope">
              <span
                    v-if="scope.row.share_type==1">{{scope.row.share_user_obj.realname ?scope.row.share_user_obj.realname :scope.row.share_user_obj.nickname }}/{{scope.row.share_user_obj.mobile}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="realname"
                           label="分享链接/昵称"
                           width="500"
                           align="left">
            <template slot-scope="scope">
              <span>{{scope.row.share_user_obj.nickname}}{{scope.row.ref_redirect_url}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="realname"
                           label="查看次数"
                           width="80"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.share_type==1">{{scope.row.statistic_count_behave_type_1}}次</span>
              <span v-else>{{scope.row.statistic_count_behave_type_4}}次</span>
            </template>
          </el-table-column>
          <el-table-column prop="statistic_count_behave_type_2"
                           label="注册人数"
                           width="80"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.share_type==1">{{scope.row.statistic_count_behave_type_2}}人</span>
              <span v-else>{{scope.row.statistic_count_behave_type_5}}人</span>
            </template>
          </el-table-column>
          <el-table-column prop="statistic_count_behave_type_3"
                           label="下单人数"
                           width="80"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.share_type==1">{{scope.row.statistic_count_behave_type_3}}人</span>
              <span v-else>{{scope.row.statistic_count_behave_type_6}}人</span>
            </template>
          </el-table-column>
          <el-table-column label="分享时间"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="100"
                           align="center"
                           fixed="right">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="text"
                         @click="handleToApplyInfo(scope.row, scope.$index)">查看记录</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>

      <el-dialog title="行为列表"
                 :close-on-click-modal="false"
                 :visible.sync="dialogVisible"
                 :append-to-body="true"
                 @open="open()"
                 width="85%">
        <el-form class="search-wrap"
                 ref="searchForm"
                 :inline="true"
                 :model="behaveQuery">
          <el-form-item label="用户信息"
                        prop="real_user_keyword">
            <el-input v-model="behaveQuery.real_user_keyword"
                      placeholder="请输入真实人姓名"
                      @input="behaveList(true)"></el-input>
          </el-form-item>
          <el-form-item label="用户行为"
                        prop="behave_type">
            <el-select v-model="behaveQuery.behave_types"
                       clearable
                       placeholder="请选择"
                       style="width: 300px"
                       @change="behaveList(true)">
              <el-option v-for="item in filter.behave_types"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="昵称"
                        prop="ref_share_nickname_keyword">
            <el-input v-model="behaveQuery.ref_share_nickname_keyword"
                      placeholder="请输入昵称关键字"
                      @input="behaveList(true)"></el-input>
          </el-form-item>
          <el-form-item label="操作时间">
            <el-date-picker class="datetime"
                            v-model="handleDatetime"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            clearable
                            @change="handletimechange"
                            style="width:400px;"
                            :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>

        </el-form>

        <el-table :data="behaveResult"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="序号"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="anon_user_id"
                           label="网络ID"
                           width="150"
                           align="left">
            <!-- <template slot-scope="scope">
              <span>-</span>
            </template> -->
          </el-table-column>
          <el-table-column prop="realname"
                           label="用户信息"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.real_user_obj">{{scope.row.real_user_obj.nickname ?scope.row.real_user_obj.nickname :scope.row.real_user_obj.realname }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="behave_type"
                           label="用户行为"
                           width="150"
                           align="left">
            <template slot-scope="scope">
              <el-link v-if="scope.row.behave_type==1"
                       type="primary">查看了此链接</el-link>
              <el-link v-if="scope.row.behave_type==4"
                       type="primary">搜索了此昵称</el-link>
              <el-link v-if="scope.row.behave_type==3"
                       type="primary">通过此分享码下单了</el-link>
              <el-link v-if="scope.row.behave_type==2"
                       type="primary">通过此分享码注册了</el-link>
              <el-link v-if="scope.row.behave_type==5"
                       type="primary">通过此昵称注册了</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="nickname"
                           label="分享人"
                           width="200"
                           align="center">
            <template>
              <span
                    v-if="rowDetail.share_user_obj">{{rowDetail.share_user_obj.realname ?rowDetail.share_user_obj.realname:rowDetail.share_user_obj.nickname }}/{{rowDetail.share_user_obj.mobile}}</span>

            </template>
          </el-table-column>
          <el-table-column prop="ref_share_redirect_url"
                           label="分享链接"
                           width="200"
                           align="center">

          </el-table-column>
          <el-table-column label="操作时间"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.handle_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="访问ip"
                           width="120"
                           align="center"
                           prop="ip">

          </el-table-column>
          <el-table-column label="设备类型"
                           width="90"
                           align="center"
                           prop="ip">
            <template slot-scope="scope">
              {{scope.row.device_type==1 ? '手机':'PC'}}
            </template>

          </el-table-column>
          <el-table-column label="操作系统"
                           width="90"
                           align="center"
                           prop="os_version">

            <template slot-scope="scope">
              {{scope.row.os_version ? scope.row.os_version:'-'}}
            </template>
          </el-table-column>
          <el-table-column label="地理位置"
                           width="160"
                           align="center"
                           prop="os_version">
            <template slot-scope="scope">
              {{scope.row.province_info}}{{scope.row.city_info}}
            </template>
          </el-table-column>

        </el-table>
        <div class="footer">
          <el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(behaveQuery.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(behaveQuery.pageSize)"
                         :total="Number(behaveTotal)"
                         @size-change="handleBehaveSizeChange"
                         @current-change="handleBehavePageChange"></el-pagination>
        </div>

      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  seniorApplyDelete,
  shareLogList,
  shareBehaveLogList,
} from '@/api/senior'

export default {
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        is_get_statistic: 1,
      },
      behaveQuery: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      },
      pageTotal: 0,
      behaveTotal: 0,
      filter: {
        behave_types: [
          {
            value: '1',
            label: '查看了此链接',
          },
          {
            value: '2',
            label: '通过此分享码注册了',
          },
          {
            value: '3',
            label: '通过此分享码下单了',
          },
          {
            value: '4',
            label: '搜索了此昵称',
          },
          {
            value: '5',
            label: '通过此昵称注册了',
          },
        ],
        statistic_types: [
          {
            value: '1',
            label: '查看分享码数倒序',
          },
          {
            value: '2',
            label: '按分享码注册数倒序',
          },
          {
            value: '3',
            label: '按分享码下单数倒序',
          },
          {
            value: '4',
            label: '按搜索昵称数倒序',
          },
          {
            value: '5',
            label: '按昵称注册数倒序',
          },
          {
            value: '6',
            label: '按昵称下单数倒序',
          },
          {
            value: '7',
            label: '按修改邀请人昵称数倒序',
          },
        ],
      },
      results: [],
      behaveResult: [],
      createDatetime: '',
      handleDatetime: '',
      dialogVisible: false,
      rowDetail: {},
    }
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.statistic_start_time = this.$moment(value[0]).valueOf()
        this.query.statistic_end_time = this.$moment(value[1]).valueOf()
      } else {
        this.query.statistic_start_time = ''
        this.query.statistic_end_time = ''
      }
    },
    handleDatetime(value) {
      if (value) {
        this.behaveQuery.handle_time_start = this.$moment(value[0]).valueOf()
        this.behaveQuery.handle_time_end = this.$moment(value[1]).valueOf()
      } else {
        this.behaveQuery.handle_time_start = ''
        this.behaveQuery.handle_time_end = ''
      }
    },
  },
  created() {
    this.fetchSeniorApplyList()
  },
  methods: {
    open() {
      this.behaveQuery.pageIndex = 1
      this.behaveResult = []
      this.behaveTotal = 0
    },
    // 申请列表
    fetchSeniorApplyList(reset = false) {
      if (reset == true) {
        this.query.pageIndex = 1
      }
      shareLogList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count || 0
        console.log('this.results', this.results)
      })
      this.syncQuery()
    },
    timechange(e) {
      if (e == null) {
        this.query.statistic_start_time = ''
        this.query.statistic_end_time = ''
      }
      this.fetchSeniorApplyList(true)
    },
    handletimechange(e) {
      console.log('e', e)
      if (e == null) {
        this.behaveQuery.handle_time_start = ''
        this.behaveQuery.handle_time_end = ''
      }
      this.behaveList(true)
    },
    handleBehaveSizeChange(val) {
      this.behaveQuery.pageSize = val
      localStorage.setItem('pageSize', val)
      this.behaveList()
    },
    handleBehavePageChange(val) {
      console.log('this.behaveQuery', this.behaveQuery)
      console.log('val', val)
      this.$set(this.behaveQuery, 'pageIndex', val)
      this.behaveList()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchSeniorApplyList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchSeniorApplyList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchSeniorApplyList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchSeniorApplyList()
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        0: '待审核',
        1: '审核通过',
        2: '审核驳回',
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    behaveList(type = false) {
      if (type) {
        this.behaveQuery.pageIndex = 1
      }
      shareBehaveLogList(this.behaveQuery).then((res) => {
        this.behaveTotal = res.count || 0
        this.behaveResult = res.list
      })
    },

    // 申请详情
    handleToApplyInfo(row) {
      this.dialogVisible = true
      this.rowDetail = row
      this.behaveQuery.share_log_id = row.id
      this.behaveList()
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    handleToRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          seniorApplyDelete({ id: row.id }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchSeniorApplyList()
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped lang="less">
.admin {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
